import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface RemoveUsersFromDataAlertsParams {
  dataAlertIds: string[];
  userIds: string[];
}

export class RemoveUsersFromDataAlertsRequest extends Request<RemoveUsersFromDataAlertsParams, IResult> {
  constructor(params: RemoveUsersFromDataAlertsParams) {
    super('removeUsersFromDataAlerts', params);
  }
}
